export const MAX_PBS_GROUP_LEVEL = 8;
